export default class ClientAddLicenciaCodeForm {
    /**
     * 
     * @param {callback} options.onSuccess
     */
    agregarCodigo(options) {
        let modalOpts = {
            title: 'Agregar código de licencia',
            method: 'PUT',
            url: '/api/licencias/registrar-codigo'
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        this.modal.render(this.render());
    }

    render() {
        return `<form>
        <div class="row form-group">
            <label for="prefijo" class="col-form-label col-12 col-md-3">Código</label>
            <div class="col-5 col-md-3">
                <input type="text" value="" id="prefijo" name="prefijo" maxlength="10" class="form-control" required autocomplete="off"/>
            </div>
            <div class="col-1 col-md-1">
                -
            </div>
            <div class="col-6 col-md-5">
                <input type="text" value="" id="codigo" name="codigo" maxlength="10" class="form-control" required autocomplete="off"/>
            </div>
        </div>
        </form>`;
    }
}